export function useGetDownloadName() {
    const { t } = useI18n();

    const getDownloadName = (type: string): string | undefined => {
        if (!type) return;

        if (type === 'document.medice-packageinsert.') {
            return t('product.downloads.packageinsert');
        } else if (type === 'document.medice-professionalinformation.') {
            return t('product.downloads.professionalinformation');
        } else if (type.includes('picture.medice-packshot')) {
            return t('product.downloads.mainPicture');
        }
        return type;
    };

    return { getDownloadName };
}
